module.exports = "<svg id=\"b3698f38-23d5-4e09-a81e-fe091300fce3\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>location</title><path d=\"M25,.53A16.39,16.39,0,0,0,8.24,17.17,19.49,19.49,0,0,0,9.62,23.4C14.29,33.55,17.95,39.31,25,49.47c7.15-10.63,11.11-16,15.77-26.07a19.12,19.12,0,0,0,1-6.23A16.45,16.45,0,0,0,25,.53Zm-.12,27A10.18,10.18,0,1,1,34.93,17.31,10.13,10.13,0,0,1,24.85,27.49Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/location.svg
// module id = UqX2
// module chunks = 1